module.exports = __webpack_public_path__ + "img/icon-ai.633bad04.svg";